import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const ChevronIcon = ({ color = 'currentColor', className = null }) => (
    <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="13.47"
        height="8.98"
        viewBox="0 0 13.47 8.98"
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
    >
        <path
            id="b"
            d="M1.06,1.06L6.85,6.85,12.41,1.3"
            fill="none"
            stroke={color}
            strokeWidth="3"
        />
    </svg>
);

ChevronIcon.propTypes = propTypes;

export default ChevronIcon;
